import React, { useEffect, useState } from 'react';
import { IColor } from '../interfaces';
import { applySVGProperties, parseSVG } from '../domain/svg-provider';
import { IconBackgroundType } from '../enums/IconBackgroundType';
import { updateFaviconDynamically } from '../domain/icons-provider';

export interface IIconPreview {
    iconSvg: string,
    size: number, // favicon size in pixels

    strokeWidth: number,
    strokeColor: IColor,
    hasStroke: boolean,

    fillColor: IColor,
    hasFill: boolean,

    backgroundColor: IColor,
    backgroundType: IconBackgroundType,

    rotation: number,
    scale: number,

    // filters
    sharpness: number,
    smoothness: number,
}

/**
 * Main stripes SVG.
 */
const IconPreview = (props: IIconPreview) => {

    const {
        iconSvg, size,
        strokeWidth, strokeColor, hasStroke,
        fillColor, hasFill,
        backgroundType, backgroundColor,
        rotation, scale,
        sharpness, smoothness,
    } = props;

    const [ svg, setSVG ] = useState(iconSvg);

    useEffect(() => {
        const $svg = parseSVG(iconSvg);
        setSVG(applySVGProperties(
            $svg,
            size,

            strokeWidth,
            strokeColor,
            hasStroke,

            fillColor,
            hasFill,

            backgroundType,
            backgroundColor,

            rotation,
            scale,

            sharpness,
            smoothness
        ));

        // update favicon on the current website in the real time for preview
        (async () => {
            if(size === 16 || size === 32) {
                await updateFaviconDynamically($svg, size);
            }
        })();
    }, [
        iconSvg, size,
        strokeWidth, strokeColor, hasStroke,
        fillColor, hasFill,
        backgroundType, backgroundColor,
        rotation, scale,
        sharpness, smoothness,
    ]);

    return (
        <div
            className="flex items-center justify-center"
            dangerouslySetInnerHTML={{ __html: svg } } />
    )
};

export default IconPreview;